import {reduceValueKeys} from '@shared/helpers/object'

import {initOrderSheetByStorage} from '@web/actions/orderSheetInfo'
import makeSlice from '@web/slices/orderTotal/sliceMaker'

import {initOrderSheetByAPI} from '../../actions'
import {ProductView} from '../../apis/response/interface'

const getAmount = (products: ProductView[]): number => {
    return products
        .map((product) => {
            const {items} = product

            const {orderAmount} = items.reduce(
                (acc, next) => {
                    if (next.orderAmount) {
                        acc.orderAmount += next.orderAmount
                    }
                    return {orderAmount: acc.orderAmount}
                },
                {orderAmount: 0},
            )
            return {
                // 상품 전체 금액
                orderAmount,
            }
        })
        .reduce((prev, {orderAmount}) => prev + orderAmount, 0)
}

const slice = makeSlice({
    extraReducers: (builder) => {
        builder
            .addCase(initOrderSheetByStorage.fulfilled, (state, {payload}) => {
                state.deliveryFeeAmount = payload.data.orderTotal.deliveryFeeAmount
            })
            .addCase(initOrderSheetByAPI.fulfilled, (state, {payload}) => {
                const {data} = payload
                state.amount = getAmount(data.products)

                state.deliveryFeeAmount = data.delivery.totalPrepayOrderDeliveryFee

                if (data.branchDeposit && data.branchDeposit.depositType) {
                    state.deposit = {
                        type: data.branchDeposit.depositType,
                        amount: data.branchDeposit.depositAmount ?? 0,
                    }
                }

                const productDiscountAmount = reduceValueKeys(
                    (acc, discounts) => {
                        return (
                            acc +
                            discounts.reduce((discountAcc, {discountAmount}) => {
                                return discountAcc + discountAmount
                            }, 0)
                        )
                    },
                    0,
                    data.coupon.discountsByItemId,
                )
                const deliveryDiscountAmount = reduceValueKeys(
                    (acc, discount) => acc + discount.discountAmount,
                    0,
                    data.coupon.deliveryFeeDiscountsByDeliveryGroupKey,
                )
                state.productDiscountAmount = productDiscountAmount
                state.deliveryDiscountAmount = deliveryDiscountAmount
                state.discountAmount = productDiscountAmount + deliveryDiscountAmount
            })
    },
})

export default slice.reducer
